var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters['form/userCanCreateFlag'] && !_vm.hasFlag && _vm.me.readonly===false)?_c('div',{},[_c('b-btn',{staticClass:"btn-flag btn-base-flag",attrs:{"size":"sm"},on:{"click":_vm.createFlag}},[_c('i',{staticClass:"mdi mdi-flag"})])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }